import React from "react";

import LoginPage from './loginMain';

export default class extends React.Component {
  render() {
    return (<LoginPage {...this.props}/>);
  }
}
